import React from "react";
import SearchBar from "components/search/SearchBar/SearchBar";
import { Heading } from "components/storages/Common";

function SmallSearchBar() {
	return (
		<SearchBar
			buttonText="Find Units"
			id="hero-search-bar"
			label="Search by location"
			theme="lightBlueSmall"
			className="rv-serach-bar"
		>
			<Heading
				className="align-center"
				content="Find Storage Units Near You"
				level="2"
				size="large"
			/>
		</SearchBar>
	);
}

export default SmallSearchBar;
